import { useEffect } from 'react';

export const useRecaptcha = (siteKey) => {
	useEffect(() => {
		if (!siteKey) {
			return;
		}

		const script = document.createElement('script');
		script.src = `https://www.google.com/recaptcha/api.js?render=${siteKey}`;
		script.async = true;
		script.defer = true;
		document.head.appendChild(script);
	}, [siteKey]);

	const getRecaptchaToken = async () => {
		const url = new URL(window.location);

		if (url.searchParams.has('reCaptcha')) {
			return url.searchParams.get('reCaptcha');
		}

		if (!window.grecaptcha) {
			console.warn('The Google reCAPTCHA script could not be executed, so no token was generated.');
			return '';
		}

		return new Promise((resolve, reject) => {
			window.grecaptcha.ready(() => {
				window.grecaptcha.execute(siteKey, { action: 'trial' }).then(resolve).catch(reject);
			});
		});
	};

	return { getRecaptchaToken };
};
